import NumericKeypad from './NumericKeypad'

export default NumericKeypad
